// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_KEY = "AIzaSyDWVTgcDy9naonaxODhtbios8JHKLRtkGI";
//
export const sheetsApi = createApi({
  reducerPath: "sheetsApi",
  baseQuery: fetchBaseQuery({
    baseUrl:
      "https://sheets.googleapis.com/v4/spreadsheets/13t5N40Knsn6zHbNOFOLm-CkRWIyb7HTcAPUoloGJltw/values/",
  }),
  endpoints: (builder) => ({
    getTransformations: builder.query({
      query: () => `Transformations?key=${API_KEY}`,
      transformResponse: (baseQueryReturnValue) => {
        const rows = baseQueryReturnValue.values;
        let formattedData = [];
        if (rows.length > 1) {
          const headers = rows[0]; // First row as headers
          formattedData = rows.slice(1).map(
            (row) =>
              Object.fromEntries(headers.map((key, i) => [key, row[i] || ""])) // Convert to object
          );
        }
        return formattedData;
      },
    }),

    getTeams: builder.query({
      query: () => `Teams?key=${API_KEY}`,
      transformResponse: (baseQueryReturnValue) => {
        const rows = baseQueryReturnValue.values;
        let formattedData = [];
        if (rows.length > 1) {
          const headers = rows[0]; // First row as headers
          formattedData = rows.slice(1).map(
            (row) =>
              Object.fromEntries(headers.map((key, i) => [key, row[i] || ""])) // Convert to object
          );
        }
        return formattedData;
      },
    }),

    getGenerals: builder.query({
      query: () => `General?key=${API_KEY}`,
      transformResponse: (baseQueryReturnValue) => {
        const rows = baseQueryReturnValue.values;
        let formattedData = [];
        if (rows.length > 1) {
          const headers = rows[0]; // First row as headers
          formattedData = rows.slice(1).map(
            (row) =>
              Object.fromEntries(headers.map((key, i) => [key, row[i] || ""])) // Convert to object
          );
        }
        return formattedData;
      },
    }),
  }),
});

export const { useGetTransformationsQuery , useGetGeneralsQuery, useGetTeamsQuery} = sheetsApi;
export const { getGenerals } = sheetsApi.endpoints;